// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { CreditCheckoutResponse, CreditsDay, CreditsSummary, CreditsUsage, FeatureDelta, ModelDelta, Pack, PersonCredits, PersonDayCredits, ProjectCredits, Reconciliation, TokenTotals } from "../credits/dto.generated";
export const addTagTypes = ["credits"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postApiWorkspacesByIdCreditsCheckout: build.mutation<
        PostApiWorkspacesByIdCreditsCheckoutApiResponse,
        PostApiWorkspacesByIdCreditsCheckoutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/checkout`,
          method: "POST",
          body: queryArg.creditsCreditCheckoutRequest,
        }),
        invalidatesTags: ["credits"],
      }),
      getApiWorkspacesByIdCreditsReconcile: build.query<
        GetApiWorkspacesByIdCreditsReconcileApiResponse,
        GetApiWorkspacesByIdCreditsReconcileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/reconcile`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["credits"],
      }),
      getApiWorkspacesByIdCreditsSummary: build.query<
        GetApiWorkspacesByIdCreditsSummaryApiResponse,
        GetApiWorkspacesByIdCreditsSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/summary`,
        }),
        providesTags: ["credits"],
      }),
      getApiWorkspacesByIdCreditsUsage: build.query<
        GetApiWorkspacesByIdCreditsUsageApiResponse,
        GetApiWorkspacesByIdCreditsUsageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/usage`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["credits"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as creditsApi };
export type PostApiWorkspacesByIdCreditsCheckoutApiResponse =
  /** status 200 OK */ { data: CreditsCreditCheckoutResponse };
export type PostApiWorkspacesByIdCreditsCheckoutApiArg = {
  /** Workspace ID */
  id: string;
  /** The pack the buyer was shown */
  creditsCreditCheckoutRequest: CreditsCreditCheckoutRequest;
};
export type GetApiWorkspacesByIdCreditsReconcileApiResponse =
  /** status 200 OK */ { data: CreditsReconciliation };
export type GetApiWorkspacesByIdCreditsReconcileApiArg = {
  /** Workspace ID */
  id: string;
  /** Window start, RFC3339. Defaults to 30 days ago. */
  from?: string;
  /** Window end, RFC3339, exclusive. Defaults to now. */
  to?: string;
};
export type GetApiWorkspacesByIdCreditsSummaryApiResponse =
  /** status 200 OK */ { data: CreditsCreditsSummary };
export type GetApiWorkspacesByIdCreditsSummaryApiArg = {
  /** Workspace ID */
  id: string;
};
export type GetApiWorkspacesByIdCreditsUsageApiResponse =
  /** status 200 OK */ { data: CreditsCreditsUsage };
export type GetApiWorkspacesByIdCreditsUsageApiArg = {
  /** Workspace ID */
  id: string;
  /** Window start, RFC3339. Defaults to 30 days ago; the window may not exceed 366 days. */
  from?: string;
  /** Window end, RFC3339, exclusive. Defaults to now. */
  to?: string;
};
export type CreditsCreditCheckoutResponse = CreditCheckoutResponse;
export type CreditsCreditCheckoutRequest = {
  pack_id?: string;
};
export type CreditsFeatureDelta = FeatureDelta;
export type CreditsModelDelta = ModelDelta;
export type CreditsReconciliation = Reconciliation;
export type CreditsPack = Pack;
export type CreditsCreditsSummary = CreditsSummary;
export type CreditsCreditsDay = CreditsDay;
export type CreditsPersonCredits = PersonCredits;
export type CreditsPersonDayCredits = PersonDayCredits;
export type CreditsProjectCredits = ProjectCredits;
export type CreditsTokenTotals = TokenTotals;
export type CreditsCreditsUsage = CreditsUsage;
export const {
  usePostApiWorkspacesByIdCreditsCheckoutMutation,
  useGetApiWorkspacesByIdCreditsReconcileQuery,
  useLazyGetApiWorkspacesByIdCreditsReconcileQuery,
  useGetApiWorkspacesByIdCreditsSummaryQuery,
  useLazyGetApiWorkspacesByIdCreditsSummaryQuery,
  useGetApiWorkspacesByIdCreditsUsageQuery,
  useLazyGetApiWorkspacesByIdCreditsUsageQuery,
} = injectedRtkApi;
